import React from 'react';

const Notifications = ({ user }) => {
  return <div>Notifications</div>;
};

export default Notifications;
